import { useFeatureFlagEnabled } from 'posthog-js/react';

/**
 * Feature flag name for telematics trips and scores functionality.
 */
const TELEMATICS_FEATURE_FLAG = 'telematics-customer-portal-trips-and-scores';

/**
 * Hook to check if the telematics feature flag is enabled.
 *
 * Controls whether telematics-related API calls are made and whether
 * telematics UI components (driver scores, trips, mileage tracking) are shown.
 *
 * This allows the telematics functionality to be toggled on/off via PostHog
 * without requiring a deployment.
 *
 * @returns Whether the telematics feature is enabled
 *
 * @example
 * ```tsx
 * const isTelematicsFeatureEnabled = useTelematicsFeature();
 *
 * useEffect(() => {
 *   if (isTelematicsFeatureEnabled && policyNumber) {
 *     dispatch(fetchDriverScores({ policyReference: policyNumber }));
 *   }
 * }, [isTelematicsFeatureEnabled, policyNumber]);
 * ```
 */
export const useTelematicsFeature = (): boolean => {
	const isEnabled = useFeatureFlagEnabled(TELEMATICS_FEATURE_FLAG);
	return isEnabled ?? false;
};

export default useTelematicsFeature;
